import { useDebouncedValue } from "@mantine/hooks";
import { GraphQL } from "@rpi/openapi-api";
import React from "react";
import { RpiFilterV2 } from "../../components/search-filter/RpiSearchFilterTypes";
import { useAuthUser } from "../../hooks/useAuthUser";
import { optArray } from "../../utils/misc.util";

export const useCustomerProductFilters = () => {
  const user = useAuthUser();

  const [customersSearch, setCustomersSearch] = React.useState("");
  const [debouncedCustomersSearch] = useDebouncedValue(customersSearch, 250);

  const { data, isLoading } = GraphQL.useAdminListCustomersQuery(
    { input: debouncedCustomersSearch },
    { enabled: user.is.SUPER_ADMIN }
  );
  const customers = React.useMemo(() => (data?.adminListCustomers || []).map((customer) => customer.publicId), [data]);

  return React.useMemo(() => {
    return RpiFilterV2.createConfigs<GraphQL.CustomerProductSearchField>([
      ...optArray<RpiFilterV2.Config<GraphQL.CustomerProductSearchField>>(user.is.SUPER_ADMIN, [
        {
          type: "dropdown",
          label: "Customer",
          field: GraphQL.CustomerProductSearchField.CustomerPublicId,
          data: customers,
          onSearch: setCustomersSearch,
          isLoading: isLoading,
        },
      ]),
      {
        type: "text",
        label: "SKU",
        field: GraphQL.CustomerProductSearchField.CustomerSku,
      },
      {
        type: "text",
        label: "Name",
        field: GraphQL.CustomerProductSearchField.Name,
      },
      {
        type: "text",
        label: "Description",
        field: GraphQL.CustomerProductSearchField.Description,
      },
    ]);
  }, [user.is, customers, isLoading]);
};
